//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataSelector from "@/components/Generics/DataSelector/DataSelector.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    components: {
        DataSelector
    },
    data() {
        return {
            showSelector: false,
            labelAndBadgeWidth: 380,
            selectorProps: {
                totalWidth: 640,
                totalheight: 480,
                anchor: "top right",
                self: "top left",
                offset: [0, 0],
                searchLabel: undefined,
                modelTreeProps: {
                    isMultiSelect: false,
                    labelAndBadgeWidth: 380,
                    onlyIndexable: false,
                    includeOnlyElements: undefined,
                    excludeElements: undefined,
                    disabledElements: undefined,
                    classAsItemFilter: undefined,
                    treeRoot: undefined
                },
                hideSources: false,
                hideSearch: false,
                hideTitle: false,
                title: "Set from",
                initialSourceSelected: "",
                sources: [
                    "dataModel",
                    "systemVariables",
                    "catalogs",
                    "dataTransfer",
                    "api",
                    "uiElements",
                    "functions",
                    "textValue"
                ],
                initialSelection: []
            },
            anchorOptions: [
                "top left",
                "top right",
                "bottom left",
                "bottom right"
            ],
            sources: [
                {
                    label: "dataModel",
                    value: "dataModel"
                },
                {
                    label: "systemVariables",
                    value: "systemVariables"
                },
                {
                    label: "catalogs",
                    value: "catalogs"
                },
                {
                    label: "dataTransfer",
                    value: "dataTransfer"
                },
                {
                    label: "api",
                    value: "api"
                },
                {
                    label: "uiElements",
                    value: "uiElements"
                },
                {
                    label: "functions",
                    value: "functions"
                },
                {
                    label: "textValue",
                    value: "textValue"
                }
            ],
            typeOptions: [
                "string", "date", "time", "datetime", "integer", "boolean", "decimal", "richtext", "attachment"],
            attrOptions: [
                { label: "isList", value: "isList", attrVal: false },
                { label: "isReference", value: "isReference", attrVal: false },
                { label: "isEmbeded", value: "isEmbeded", attrVal: false },
                { label: "isIndexable", value: "isIndexable", attrVal: false },
                { label: "isBCReady", value: "isBCReady", attrVal: false },
                { label: "isCat", value: "isCat", attrVal: false },
                { label: "isPersonalInformation", value: "isPersonalInformation", attrVal: false }
            ],
            includeTypes: [],
            includeAttrs: [],
            excludeTypes: [],
            excludeAttrs: [],
            disableTypes: [],
            disableAttrs: [],
            classAsItem: []
        };
    },
    computed: {
        ...mapGetters("apps", ["appDDL"]),
        ...mapGetters("main", ["getCurrentApplicationId"])
    },
    watch: {
        showSelector: {
            handler(newVal) {
                if (newVal) {
                    console.log("modelTreeProps", this.selectorProps.modelTreeProps);
                }
            }
        },
        includeTypes: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.includeOnlyElements) {
                        modelTreeProps.includeOnlyElements = {};
                    }
                    modelTreeProps.includeOnlyElements.type = newVal.reduce((acc, el) => {
                        acc[el] = true;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.includeOnlyElements.type;
                    if (!modelTreeProps.includeOnlyElements.attr) {
                        modelTreeProps.includeOnlyElements = undefined;
                    }
                }
            },
            deep: true
        },
        includeAttrs: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.includeOnlyElements) {
                        modelTreeProps.includeOnlyElements = {};
                    }
                    modelTreeProps.includeOnlyElements.attr = newVal.reduce((acc, el) => {
                        acc[el.value] = el.attrVal;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.includeOnlyElements.attr;
                    if (!modelTreeProps.includeOnlyElements.type) {
                        modelTreeProps.includeOnlyElements = undefined;
                    }
                }
            },
            deep: true
        },
        excludeAttrs: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.excludeElements) {
                        modelTreeProps.excludeElements = {};
                    }
                    modelTreeProps.excludeElements.attr = newVal.reduce((acc, el) => {
                        acc[el.value] = el.attrVal;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.excludeElements.attr;
                    if (!modelTreeProps.excludeElements.type) {
                        modelTreeProps.excludeElements = undefined;
                    }
                }
            },
            deep: true
        },
        excludeTypes: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.excludeElements) {
                        modelTreeProps.excludeElements = {};
                    }
                    modelTreeProps.excludeElements.type = newVal.reduce((acc, el) => {
                        acc[el] = true;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.excludeElements.type;
                    if (!modelTreeProps.excludeElements.attr) {
                        modelTreeProps.excludeElements = undefined;
                    }
                }
            },
            deep: true
        },
        disableAttrs: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.disabledElements) {
                        modelTreeProps.disabledElements = {};
                    }
                    modelTreeProps.disabledElements.attr = newVal.reduce((acc, el) => {
                        acc[el.value] = el.attrVal;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.disabledElements.attr;
                    if (!modelTreeProps.disabledElements.type) {
                        modelTreeProps.disabledElements = undefined;
                    }
                }
            },
            deep: true
        },
        disableTypes: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    if (!modelTreeProps.disabledElements) {
                        modelTreeProps.disabledElements = {};
                    }
                    modelTreeProps.disabledElements.type = newVal.reduce((acc, el) => {
                        acc[el] = true;
                        return acc;
                    }, {});
                } else {
                    delete modelTreeProps.disabledElements.type;
                    if (!modelTreeProps.disabledElements.attr) {
                        modelTreeProps.disabledElements = undefined;
                    }
                }
            },
            deep: true
        },
        classAsItem: {
            handler(newVal) {
                const { modelTreeProps } = this.selectorProps;
                if (newVal?.length) {
                    modelTreeProps.classAsItemFilter = newVal.reduce((acc, el) => {
                        acc[el.value] = el.attrVal;
                        return acc;
                    }, {});
                } else {
                    modelTreeProps.classAsItemFilter = undefined;
                }
            },
            deep: true
        },
        "selectorProps.sources": {
            handler(newVal) {
                if (!newVal.includes(this.selectorProps.initialSourceSelected)) {
                    this.selectorProps.initialSourceSelected = null;
                }
            }
        },
        "selectorProps.modelTreeProps.isMultiSelect": {
            handler() {
                this.clearSelection();
            }
        },
        labelAndBadgeWidth: {
            handler(newVal) {
                if (newVal === "" || newVal === null || newVal === undefined) {
                    this.selectorProps.modelTreeProps.labelAndBadgeWidth = undefined;
                } else {
                    this.selectorProps.modelTreeProps.labelAndBadgeWidth = `${newVal}px`;
                }
            },
            immediate: true
        },
        getCurrentApplicationId: {
            handler() {
                this.clearSelection();
            }
        }
    },
    created() {
        this.getAllApps();
    },
    methods: {
        ...mapActions("apps", ["getAllApps"]),
        ...mapMutations("main", ["setCurrentApplicationId"]),
        setSelection(ev) {
            this.selectorProps.initialSelection = ev.map(({ model }) => ({ model }));
        },
        setCurrentAppId(value) {
            this.setCurrentApplicationId(value);
        },
        clearSelection() {
            this.selectorProps.initialSelection = [];
        }
    }
};

